// Pages CSE — hub national + pages locales réellement différenciées.
// Règle d'honnêteté : aucun prix affiché (formules sur devis), aucun client nommé,
// lieux cités comme repérés/possibles, jamais comme partenaires.

export const CSE_OFFERS = [
  {
    id: "arbre-de-noel",
    title: "Arbre de Noël CSE",
    text: "Le rendez-vous de fin d'année des salariés et de leurs enfants : nous le concevons comme un vrai spectacle familial, dans vos locaux ou dans une salle privatisée.",
    inclus: ["Père Noël et parade de Noël", "Animations enfants : maquillage, ateliers, structures gonflables", "Spectacle et temps forts scéniques", "Goûter et stands gourmands", "Décoration et sapin", "Accueil des familles et coordination le jour J"],
  },
  {
    id: "family-day",
    title: "Family Day & journée du personnel",
    text: "Une journée qui réunit salariés et familles, en plein air ou sur site : nous apportons les animations, la restauration et toute la logistique.",
    inclus: ["Jeux géants et animations familiales", "Food trucks, stands gourmands et buvette", "Bar mobile (cocktails avec ou sans alcool)", "Tentes, mobilier et sonorisation", "Sécurité et signalétique", "Coordination complète de la journée"],
  },
  {
    id: "soiree-cse",
    title: "Soirée CSE & événements festifs",
    text: "Soirées à thème, soirées dansantes ou cocktails de fin d'année : une organisation festive pensée pour tous les âges et tous les goûts.",
    inclus: ["Soirées à thème et scénographie", "DJ, musiciens et artistes", "Bar à cocktails et bar mobile", "Traiteur et restauration", "Hôtesses et personnel événementiel", "Technique son, lumière et vidéo"],
  },
  {
    id: "team-building",
    title: "Team building & sorties collectives",
    text: "Cohésion d'équipe, challenges, journées découverte : des activités calibrées à votre nombre de participants et à vos objectifs.",
    inclus: ["Activités de cohésion et challenges", "Journées découverte (nature, sport, culture)", "Séminaires et conventions CSE", "Encadrement et animateurs", "Restauration sur place ou pique-nique premium", "Transport et logistique si besoin"],
  },
];

export const CSE_FAQ = [
  { q: "Le budget ASC peut-il financer ces événements ?", r: "Pour les entreprises de 50 salariés et plus, les événements destinés aux salariés et à leurs familles relèvent généralement des activités sociales et culturelles (ASC), dont le budget est distinct du budget de fonctionnement. Vérifiez vos modalités de versement — nous adaptons nos propositions à votre enveloppe." },
  { q: "Les élus CSE sont bénévoles : combien de temps cela nous demande-t-il ?", r: "Le moins possible. Un chef de projet unique prépare tout : proposition, lieux, prestataires, planning et coordination le jour J. Vous validez les grandes étapes, nous gérons le reste." },
  { q: "Intervenez-vous dans nos locaux ou faut-il une salle ?", r: "Les deux. Arbres de Noël et family days fonctionnent très bien dans vos locaux ou votre cour ; sinon, nous proposons des salles et sites repérés près de chez vous." },
  { q: "Quels délais prévoir ?", r: "Pour un arbre de Noël, contactez-nous idéalement dès septembre-octobre ; pour un family day de printemps, 2 à 3 mois avant. Une urgence ? Nous étudions toujours la faisabilité." },
];

export const CSE_CITIES = {
  lyon: {
    slug: "lyon",
    name: "Lyon",
    code: "69123",
    dept: "Rhône",
    seoTitle: "Arbre de Noël CSE Lyon | Spectacle, animations et goûter",
    seoDescription: "Organisation d'arbres de Noël CSE à Lyon : Père Noël, spectacle, animations enfants, goûter, distribution de cadeaux et coordination. Interlocuteur unique, devis sous 24 h ouvrées.",
    h1: "Organisation d'un arbre de Noël CSE à Lyon",
    intro: "L'arbre de Noël est le rendez-vous préféré des salariés et de leurs enfants — et le plus exigeant à organiser pour des élus bénévoles. Lyon est notre ville de base : nous coordonnons spectacle, animations, goûter et cadeaux dans vos locaux ou dans une salle privatisée, sans frais de déplacement dans la métropole. Family days, soirées CSE et team building restent au programme toute l'année.",
    noelHighlight: {
      title: "Votre arbre de Noël CSE, de la décoration à la distribution des cadeaux",
      items: [
        "Père Noël et séance photo",
        "Spectacle de magie, cirque ou marionnettes",
        "Maquillage et sculpture de ballons",
        "Ateliers créatifs",
        "Photobooth",
        "Stands crêpes, gaufres et chocolat chaud",
        "Distribution de cadeaux",
        "Décoration, sapin et mobilier",
        "Accueil des familles et vestiaire",
        "Personnel, sécurité et coordination",
      ],
    },
    lieux: [
      { name: "Vos locaux et espaces d'entreprise", detail: "Arbres de Noël et family days sur site — nous apportons tout" },
      { name: "Halle Tony Garnier", detail: "Très grands arbres de Noël et journées du personnel" },
      { name: "Eurexpo", detail: "Grands formats et manifestations familiales — est lyonnais" },
      { name: "Péniches et berges de Saône", detail: "Soirées CSE estivales et cocktails" },
      { name: "Parcs et domaines de la métropole", detail: "Family days en plein air, repérés selon votre secteur" },
    ],
    logistique: "Basés à Lyon Part-Dieu, nous intervenons dans toute la métropole sans surcoût de déplacement : repérage, montage et démontage assurés par notre coordination, même le week-end.",
    related: [
      { label: "Notre agence événementielle à Lyon", to: "/agence-evenementielle-entreprise-lyon" },
      { label: "Fête de Noël d'entreprise à Lyon", to: "/fete-de-noel-entreprise/lyon" },
      { label: "Soirée d'entreprise à Lyon", to: "/soiree-entreprise-lyon" },
    ],
  },
  grenoble: {
    slug: "grenoble",
    name: "Grenoble",
    code: "38185",
    dept: "Isère",
    seoTitle: "Événements CSE à Grenoble | Arbre de Noël, Family Day, Soirées",
    seoDescription: "Organisation d'événements CSE à Grenoble et en Isère : arbre de Noël, journée du personnel, family day, soirée CSE. Interlocuteur unique, devis sous 24 h ouvrées.",
    h1: "Organisation d'événements CSE à Grenoble",
    intro: "Grenoble et l'Isère comptent de grands bassins d'emploi industriels et technologiques, avec des CSE très actifs. Depuis notre base lyonnaise (environ 1 h 15 de route), nous organisons sur place arbres de Noël, family days et soirées du personnel, en intérieur comme en extérieur.",
    lieux: [
      { name: "Vos sites et vos locaux", detail: "Le format le plus simple pour un arbre de Noël ou une journée familles" },
      { name: "Alpexpo", detail: "Grands événements CSE et journées du personnel" },
      { name: "WTC Grenoble", detail: "Soirées et formats corporate en centre-ville" },
      { name: "Parcs grenoblois (Paul Mistral, domaine universitaire)", detail: "Family days en plein air" },
      { name: "Domaines et châteaux de la métropole", detail: "Soirées CSE dans un cadre marquant" },
    ],
    logistique: "Le déplacement depuis Lyon est intégré à notre organisation : matériel acheminé par nos soins, montage et démontage coordonnés, sans multiplier vos interlocuteurs.",
    related: [
      { label: "Notre agence événementielle à Grenoble", to: "/agence-evenementielle-grenoble" },
      { label: "Événements CSE — vue d'ensemble", to: "/evenements-cse" },
    ],
  },
  valence: {
    slug: "valence",
    name: "Valence",
    code: "26362",
    dept: "Drôme",
    seoTitle: "Événements CSE à Valence | Arbre de Noël, Family Day, Soirées",
    seoDescription: "Organisation d'événements CSE à Valence et dans la Drôme : arbre de Noël, journée du personnel, family day, soirée CSE. Interlocuteur unique, devis sous 24 h ouvrées.",
    h1: "Organisation d'événements CSE à Valence",
    intro: "Valence et la Drôme sont une zone que nous couvrons chaque semaine, à 1 h de notre base lyonnaise. Les CSE valentinois nous confient leurs arbres de Noël, journées du personnel et soirées : nous coordonnons animations, restauration et logistique, sur vos sites ou dans les lieux du territoire.",
    lieux: [
      { name: "Vos locaux et sites d'entreprise", detail: "Arbres de Noël et journées familles directement chez vous" },
      { name: "Parc Expo de Valence", detail: "Grands arbres de Noël et journées du personnel" },
      { name: "Mas de Crussol (Guilherand-Granges)", detail: "Soirées et réceptions CSE face à la vallée" },
      { name: "Cité du Chocolat Valrhona (Tain-l'Hermitage)", detail: "Family days et sorties gourmandes" },
      { name: "Domaines viticoles des Crozes-Hermitage", detail: "Soirées CSE et journées du personnel au vert" },
    ],
    logistique: "La Drôme est desservie sans friction depuis Lyon : pas de surcoût caché, le chiffrage intègre transport, montage et démontage, détaillé dans votre devis.",
    related: [
      { label: "Notre agence événementielle à Valence", to: "/agence-evenementielle-valence" },
      { label: "Événements CSE — vue d'ensemble", to: "/evenements-cse" },
    ],
  },
  chambery: {
    slug: "chambery",
    name: "Chambéry",
    code: "73065",
    dept: "Savoie",
    seoTitle: "Événements CSE à Chambéry | Arbre de Noël, Family Day, Soirées",
    seoDescription: "Organisation d'événements CSE à Chambéry et en Savoie : arbre de Noël, journée du personnel, family day, soirée CSE. Interlocuteur unique, devis sous 24 h ouvrées.",
    h1: "Organisation d'événements CSE à Chambéry",
    intro: "Chambéry et la Savoie comptent de nombreux sites industriels et tertiaires avec des CSE actifs. Depuis Lyon (environ 1 h 15 par l'A43), nous organisons arbres de Noël, journées du personnel et soirées pour les comités chambériens, en gérant l'intégralité du déplacement et du montage.",
    lieux: [
      { name: "Vos locaux et sites d'entreprise", detail: "Le format le plus simple : nous apportons animations, goûter et décoration" },
      { name: "Le Phare — Chambéry Métropole", detail: "Grande salle modulable pour arbres de Noël et soirées CSE" },
      { name: "Le Manège — Parc des expositions", detail: "Journées du personnel et grands formats" },
      { name: "Rives du lac du Bourget", detail: "Family days et soirées d'été au bord de l'eau (Aix-les-Bains)" },
      { name: "Domaines et châteaux de Savoie", detail: "Soirées CSE dans un cadre patrimonial, repérés selon votre secteur" },
    ],
    logistique: "L'axe Lyon–Chambéry est quotidien pour nos équipes : transport du matériel, montage et démontage intégrés au devis, sans multiplier vos interlocuteurs.",
    related: [
      { label: "Notre agence événementielle à Chambéry & Annecy", to: "/agence-evenementielle-chambery-annecy" },
      { label: "Événements CSE — vue d'ensemble", to: "/evenements-cse" },
    ],
  },
  annecy: {
    slug: "annecy",
    name: "Annecy",
    code: "74010",
    dept: "Haute-Savoie",
    seoTitle: "Événements CSE à Annecy | Arbre de Noël, Family Day, Soirées",
    seoDescription: "Organisation d'événements CSE à Annecy et en Haute-Savoie : arbre de Noël, journée du personnel, family day au bord du lac, soirée CSE. Devis sous 24 h ouvrées.",
    h1: "Organisation d'événements CSE à Annecy",
    intro: "Annecy et la Haute-Savoie concentrent des entreprises industrielles et des sièges dynamiques, avec une forte culture des événements de salariés. Nous organisons pour les CSE annéciens des arbres de Noël, des family days au bord du lac et des soirées, avec une coordination complète depuis notre base lyonnaise.",
    lieux: [
      { name: "Vos locaux et sites d'entreprise", detail: "Arbres de Noël et journées familles directement sur site" },
      { name: "Bonlieu — Scène nationale", detail: "Spectacles et soirées CSE en centre-ville" },
      { name: "Rives du lac et pelouses d'Albigny", detail: "Family days en plein air face au lac" },
      { name: "Salles des Pays d'en Haut et de la vallée", detail: "Arbres de Noël de proximité, repérés selon votre bassin" },
      { name: "Domaines entre lac et montagnes", detail: "Soirées CSE dans un cadre alpin" },
    ],
    logistique: "Annecy est à environ 1 h 45 de Lyon : le chiffrage intègre transport, montage et démontage, détaillé poste par poste dans votre devis.",
    related: [
      { label: "Notre agence événementielle à Chambéry & Annecy", to: "/agence-evenementielle-chambery-annecy" },
      { label: "Événements CSE — vue d'ensemble", to: "/evenements-cse" },
    ],
  },
  "saint-etienne": {
    slug: "saint-etienne",
    name: "Saint-Étienne",
    code: "42218",
    dept: "Loire",
    seoTitle: "Événements CSE à Saint-Étienne | Arbre de Noël, Family Day, Soirées",
    seoDescription: "Organisation d'événements CSE à Saint-Étienne et dans la Loire : arbre de Noël, journée du personnel, family day, soirée CSE. Interlocuteur unique, devis sous 24 h ouvrées.",
    h1: "Organisation d'événements CSE à Saint-Étienne",
    intro: "Saint-Étienne et la Loire ont un tissu industriel dense, avec des CSE historiquement très investis dans la vie des salariés. À moins d'une heure de notre base lyonnaise, nous y organisons arbres de Noël, journées du personnel et soirées festives, dans vos locaux ou dans les lieux stéphanois.",
    lieux: [
      { name: "Vos locaux et sites industriels", detail: "Le réflexe des CSE stéphanois : nous équipons vos espaces" },
      { name: "Cité du Design", detail: "Journées du personnel et formats créatifs" },
      { name: "Zénith de Saint-Étienne", detail: "Très grands arbres de Noël et spectacles" },
      { name: "Parc du musée de la Mine et sites patrimoniaux", detail: "Family days dans le patrimoine stéphanois" },
      { name: "Salles et domaines de la plaine du Forez", detail: "Soirées CSE, repérées selon votre secteur" },
    ],
    logistique: "Saint-Étienne est notre zone la plus proche après Lyon : déplacements sans surcoût significatif, montage et démontage coordonnés par notre équipe.",
    related: [
      { label: "Notre agence événementielle à Saint-Étienne", to: "/agence-evenementielle-saint-etienne" },
      { label: "Événements CSE — vue d'ensemble", to: "/evenements-cse" },
    ],
  },
};

export const CSE_HUB = {
  seoTitle: "Événements CSE : Arbre de Noël, Family Day, Soirée du Personnel",
  seoDescription: "Organisation d'événements pour CSE : arbre de Noël, family day, journée du personnel, soirée CSE et team building. Un interlocuteur unique, du choix des animations à la coordination le jour J.",
  h1: "Organisation d'événements pour CSE",
};
